import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, withDefaults } from 'vue';
import { useRouter } from 'vue-router';
import {
  BaseDialog,
  BaseTextContent,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseButton,
  BaseSelect,
  XrkMessage
} from 'xrk-components';
import { SCENE_MAPPING } from '../constants/index';
import { list } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-add-dialog',
  props: {
    remove: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

const formData = ref({
  sceneType: null,
  templateId: null
});
const baseFormRef = ref<BaseFormRef>(null);

const remoteMethod = async (templateName: string) => {
  if (!formData.value.sceneType) {
    return XrkMessage.error('请先选择关联内容');
  }
  return list({
    sceneType: formData.value.sceneType,
    templateName,
    pageNum: 1,
    pageSize: 50
  });
};

const onCancel = () => {
  props?.remove?.();
};
const onConfirm = async () => {
  await baseFormRef.value.validate();
  props?.remove?.();
  router.push({
    name: 'bi-tmpl-detail',
    query: {
      id: formData.value.templateId,
      sceneType: formData.value.templateId
        ? undefined
        : formData.value.sceneType
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    class: "bi-tmpl-add-dialog",
    title: "新增模板",
    width: "500px"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { click: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "baseFormRef",
            ref: baseFormRef,
            "label-position": "top",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                prop: "sceneType",
                label: "关联内容",
                rules: [
            {
              required: true,
              message: '请选择关联内容',
              trigger: 'change'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    options: 
              Object.values(_unref(SCENE_MAPPING)).sort((a, b) => a.sort - b.sort)
            ,
                    modelValue: formData.value.sceneType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.sceneType) = $event))
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                prop: "templateId",
                label: "从已有模板快速创建"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    clearable: "",
                    filterUseRemote: "",
                    "value-key": "id",
                    "label-key": "templateName",
                    remoteMethod: remoteMethod,
                    modelValue: formData.value.templateId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.templateId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})